import * as React from "react";
const SvgTrash = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M3.33331 5H16.6666M13.3333 5L13.1078 4.32339C12.8892 3.66771 12.7799 3.33987 12.5772 3.09748C12.3982 2.88345 12.1684 2.71777 11.9087 2.61565C11.6147 2.5 11.2691 2.5 10.578 2.5H9.422C8.73085 2.5 8.38528 2.5 8.09123 2.61565C7.83158 2.71777 7.60171 2.88345 7.42272 3.09748C7.22002 3.33987 7.11074 3.66771 6.89218 4.32339L6.66665 5M15 5V13.5C15 14.9001 15 15.6002 14.7275 16.135C14.4878 16.6054 14.1054 16.9878 13.635 17.2275C13.1002 17.5 12.4001 17.5 11 17.5H8.99998C7.59985 17.5 6.89978 17.5 6.365 17.2275C5.8946 16.9878 5.51215 16.6054 5.27246 16.135C4.99998 15.6002 4.99998 14.9001 4.99998 13.5V5M11.6666 8.33333V14.1667M8.33331 8.33333V14.1667",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgTrash;
